export default __webpack_public_path__ + "static/media/icon-complete.520e641a.svg";